import { render, staticRenderFns } from "./Liquid.vue?vue&type=template&id=79d83cc6&scoped=true&"
import script from "./Liquid.vue?vue&type=script&lang=js&"
export * from "./Liquid.vue?vue&type=script&lang=js&"
import style0 from "./Liquid.vue?vue&type=style&index=0&id=79d83cc6&prod&lang=scss&scoped=true&"
import style1 from "./Liquid.vue?vue&type=style&index=1&id=79d83cc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d83cc6",
  null
  
)

export default component.exports